import { useEffect, useState } from "react";
import { AppBox, AppContainer, AppGridBox, AppTitle } from "../../../commons/components";
import { useAppDispatch } from "../../../hooks/app";
import { setPageTitle } from "../../../redux/slices/page-title-slice";
import { setToolbarSearchEnabled } from "../../../redux/slices/toolbar-search-slice";
import setDocumentTitle from "../../../commons/utilities/document-title";
import MatchList from "./components/MatchList";
import TeamStatisticsList from "./components/TeamStatisticsList";
import ability, { Can } from "../../../casl/Can";
import { RolePolicyActionEnum } from "../../../commons/enums/role-policy-action.enum";
import { ManageFootballTeam } from "../../../commons/models/football/admin/manage-football-team";
import { ManageFootballCompetition } from "../../../commons/models/football/admin/manage-football-competition";
import TournamentStandingList from "./components/TournamentStandingsList";
import { ManageFootballPlayer } from "../../../commons/models/football/admin/manage-football-player";
import PlayerStatistics from "./components/PlayerStatistics";
import useAuth from "../../../hooks/useAuth";
import { fetchManagePlayer } from "../../../redux/slices/football/admin/player/manage-player-slice";

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth();
  const [isPlayer, setIsPlayer] = useState<boolean>(false);

  useEffect(() => {
    dispatch(setPageTitle("Dashboard"));
    setDocumentTitle(["Dashboard"]);
    dispatch(setToolbarSearchEnabled(false));
  }, []);

  useEffect(() => {
    if (user.id) {
      let playerPolicy = user.policies.find(
        (policy) => policy.conditionKey === "isPlayer" && policy.subjectId !== null
      );
      if (playerPolicy) {
        setIsPlayer(true);
        dispatch(fetchManagePlayer(Number(playerPolicy.subjectId)));
      }
    }
  }, [user]);

  return (
    <AppContainer>
      <AppGridBox columns={2} gap="2xs" style={{ gridTemplateColumns: "3.5fr 2.75fr" }}>
        <AppBox
          className="w-100"
          px="3xs"
          style={{
            height: "calc(100vh - 80px)",
            overflow: "auto",
            scrollBehavior: "smooth",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <MatchList />
        </AppBox>
        <AppBox
          px="3xs"
          flexDirection="column"
          gap="sm"
          className="w-100"
          style={{
            height: "calc(100vh - 80px)",
            overflow: "auto",
            scrollBehavior: "smooth",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {isPlayer && <PlayerStatistics />}
          {ability.can(RolePolicyActionEnum.READ, ManageFootballTeam) && <TeamStatisticsList />}
          {/* {ability.can(RolePolicyActionEnum.READ, ManageFootballCompetition) && <TournamentStandingList />} */}
        </AppBox>
      </AppGridBox>
    </AppContainer>
  );
};

export default Dashboard;
